"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const muiButton = {
    styleOverrides: {
        root: {
            borderRadius: '16px',
            textTransform: 'none',
        },
    },
};
exports.default = muiButton;
//# sourceMappingURL=muiButton.js.map